export default {
    personal_token_page_title: 'Personal Token Center',
    personal_token_create: '+ Create Personal Token',
    personal_token_name: 'Token Name',
    personal_token_type: 'Token Type',
    personal_token_value: 'Personal Token',
    personal_token_type_personal_token: 'Personal Token',
    personal_token_type_game_wiki: 'GameWiki Token',
    personal_token_expire_time: 'Expires At',
    personal_token_view: 'View',
    personal_token_renew: 'Renew',
    personal_token_revoke: 'Revoke',

    personal_token_create_modal_title: 'Create Personal Token',
    personal_token_detail_modal_title: 'Token Details',
    personal_token_revoke_modal_title: 'Revoke Personal Token',

    personal_token_name_placeholder: 'Please enter token name',
    personal_token_name_required: 'Please enter token name',
    personal_token_name_too_long: 'Token name must be within 50 characters',
    personal_token_name_invalid: 'Only Chinese/letters/numbers/underscore are allowed',

    personal_token_security_warning:
      'Please keep your personal token safe and do not disclose it to others.',
    personal_token_valid_90_days: 'Valid for 90 days',
    personal_token_show: 'Show',
    personal_token_hide: 'Hide',
    personal_token_copy: 'Copy Token',

    personal_token_type_game_wiki_exists_tip:
      'A gamewiki token already exists in the list. To create a new one, please revoke the existing gamewiki token first.',

    personal_token_valid_12_months: 'Valid for 12 months',
    personal_token_renew_confirm_title: 'Renew this personal token?',
    personal_token_renew_confirm_desc:
      'After renewal, the old token will be invalid and the new token will be valid for 90 days.',
    personal_token_renew_confirm_desc_game_wiki:
      'After renewal, the old token will be invalid and the new gamewiki token will be valid for 12 months.',

    personal_token_revoke_warning:
      'After revocation, the token will be invalid immediately and removed from the list.',
    personal_token_revoke_confirm: 'Confirm Revoke',

    personal_token_list_failed: 'Failed to load personal token list. Please try again later.',
    personal_token_create_success: 'Created successfully.',
    personal_token_create_failed: 'Create failed. Please try again later.',
    personal_token_detail_failed: 'Failed to fetch token details. Please try again later.',
    personal_token_not_found: 'Token not found.',
    personal_token_already_revoked: 'Token has already been revoked.',
    personal_token_service_error: 'Token service error. Please try again later.',
    personal_token_renew_success: 'Renewed successfully.',
    personal_token_renew_failed: 'Renew failed. Please try again later.',
    personal_token_revoke_success: 'Revoked successfully.',
    personal_token_revoke_failed: 'Revoke failed. Please try again later.',
  };